import _ from 'lodash'
import Store from '@/modules/core/vuex/Store'
import { RootState } from '@/store/types'
import { Metadata } from '@/modules/seo/types'

export default class BaseSEOCompletor {
    constructor (protected store: Store<RootState>) {}

    /**
     * Permite obtener los campos SEO modificados por el usuario
     */
    private get touchedFields (): Map<string, string[]> {
        return this.store.get('seo.touchedMetadataFields', new Map())
    }

    /**
     * Comprueba si un campo ha sido modificado por el usuario
     *
     * @param locale
     * @param fieldName
     */
    private fieldIsTouched (locale: string, fieldName: string) {
        return this.store.getters['seo/metadata/field/isTouched'](locale, fieldName)
    }

    /**
     * Actualiza una lista de campos de la entidad Metadata
     *
     * @param metadata { Metadata }
     * @param locale { string }
     * @param value { object }
     */
    protected updateFields (metadata: Metadata, locale: string, values: object) {
        _.forOwn(values, (fieldName: string, value: any) => {
            this.updateField(metadata, locale, fieldName, value)
        })
    }

    /**
     * Actualiza un campo de la entidad metadata
     *
     * @param metadata
     * @param locale
     * @param fieldName
     * @param value
     */
    protected updateField (metadata: Metadata, locale: string, fieldName: string, value: any) {
        // Si el campo ha sido modificado por el usuario no sera autocompletado
        if (this.fieldIsTouched(locale, fieldName)) {
            return
        }

        const translation = metadata.translate(locale)
        if (!translation) {
            return
        }

        _.set(translation, fieldName, value)

        return metadata
    }

    /**
     * Comparación de campos
     *
     * Compara los campos listados en comparisonMap, donde clave del mapa es el
     * nombre del campo de entityA y el valor es el campo de entityB.
     *
     * La función devolverá todas las claves de comparisonMap cuyo valor
     * sea distinto en ambos objetos
     */
    protected compareFields (entityA: object, entityB: object, comparisonMap: object) {
        const touchedFields: string[] = []
        _.forOwn(comparisonMap, (value, key) => {
            const seoValue = _.get(entityA, key)
            const entityValue = _.get(entityB, value)

            if (seoValue === entityValue) {
                return
            }

            touchedFields.push(key)
        })

        return touchedFields
    }
}
